import React from 'react';
import { useNewAptitudeTestScoreQuery } from './NewGsapQuizSlice';
import { Navigate } from 'react-router-dom';
import Loading from 'components/global/layout/Loading';
import CheckQuizStatus from './CheckQuizStatus';

const NewCheckGsapAttempt = () => {
  // changed this: useNewAptitudeAttemptQuery , according to new aptitude slice
  const { isLoading, isSuccess, isError, data } =
    useNewAptitudeTestScoreQuery();

  return (
    <div>
      {isError && <div> Error... </div>}
      {isLoading && (
        <div>
          <Loading />{' '}
        </div>
      )}
      {isSuccess && (
        <>
          {data?.timeTaken ? (
            <Navigate to='/quiz/new-aptitude/scorecard' replace />
          ) : (
            <CheckQuizStatus />
          )}
        </>
      )}
    </div>
  );
};

export default NewCheckGsapAttempt;
